import React, { Fragment, useEffect, useState } from 'react';
import { Col, Form, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import "./DocumentType.css";
import { createDocumentType } from '../../../api/workflow';
import Loader from '../../../components/Loader/Loader';
import { failed, success } from '../../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import MultiSelect from '../../../components/InputFields/MultiSelect';
import { useGetStates } from '../../../hooks/useGetStates';
const AddDocumentType = ({ setCurrentTab }) => {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const { states } = useGetStates("US");
    const [statesList, setStateList] = useState([]);
    const [isManageAdmin, setIsManageAdmin] = useState(false);

    useEffect(() => {
        if (states && states.length > 0) {
            const formattedStates = states.map((obj) => ({
                label: obj.name,
                value: obj.name
            }));
            setStateList(formattedStates);
        }
    }, [states]);

    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            documentTitle: '',
            applicableStates: []
        },
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                const payload = {
                    ...values,
                    isManageAdmin
                };

                res = await createDocumentType({ values: payload, dispatch, token });
                if (res?.status === "SUCCESS") {
                    setIsLoading(false);
                    success(res?.message);
                    formik.resetForm();
                    formik.setFieldValue("applicableStates", []);
                    setCurrentTab("documentTypeList");
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
            }
        }
    });

    useEffect(() => {
        if (isManageAdmin) {
            formik.setFieldValue("applicableStates", statesList);
        }
    }, [isManageAdmin, statesList]);

    const handleStates = (selectedStates) => {
        if (!isManageAdmin) {
            formik.setFieldValue("applicableStates", selectedStates);
        }
    };

    const toggleAdminManage = () => {
        const newAdminManageState = !isManageAdmin;
        setIsManageAdmin(newAdminManageState);

        if (newAdminManageState) {
            // Select all states and disable the dropdown
            formik.setFieldValue("applicableStates", statesList);
        } else {
            // Reset selection (like page refresh)
            formik.setFieldValue("applicableStates", []);
        }
    };

    return (
        <Fragment>
            {isLoading && <Loader />}
            <div className="add_document_type">
                <h6 className="block_name text-center">Create Required Document</h6>
                <Form onSubmit={formik.handleSubmit}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
                            e.preventDefault();
                        }
                    }}
                >
                    <div className="first_block">
                        {/* <h6 className="block_name text-center mt-0">Create Document Type</h6> */}
                        <Row>
                            <Col lg={6} className="location_block mb-3">
                                <TextInput
                                    keyField={"documentTitle"}
                                    formik={formik}
                                    label="Required Document Name"
                                    placeholder={"Required Document Name"}
                                    type="text"
                                    value={formik.values.documentTitle}
                                    onChange={(e) => formik.setFieldValue("documentTitle", e.target.value)}
                                />
                            </Col>
                            <Col lg={6} className="location_block mb-3">
                                <MultiSelect
                                    keyField={"applicableStates"}
                                    formik={formik}
                                    label="Applicable States"
                                    options={statesList}
                                    type="select"
                                    placeholder="Applicable States"
                                    value={formik.values.applicableStates}
                                    onChange={handleStates}
                                    disabled={isManageAdmin}
                                />
                            </Col>
                            <Col lg={6} className="location_block mb-3">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        checked={isManageAdmin}
                                        onChange={toggleAdminManage}
                                    />
                                    Admin Manage (Select for all states)
                                </label>
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex gap-3 justify-content-center">
                        <button className="save_btn" type="submit">Save</button>
                        <button className="save_btn cancel_btn" onClick={() => setCurrentTab("documentTypeList")}>Cancel</button>
                    </div>
                </Form>
            </div>
        </Fragment>
    );
};

export default AddDocumentType;

